import type { Bom, BomStatus } from '@/services/boms'

export type BomListKpis = {
  total: number
  active: number
  inactive: number
}

export function computeBomListKpis(rows: Bom[]): BomListKpis {
  let active = 0
  let inactive = 0
  for (const r of rows) {
    if (r.status === 'active') active += 1
    else if (r.status === 'inactive') inactive += 1
  }
  return { total: rows.length, active, inactive }
}

export function countBomsByStatus(rows: Bom[], status: BomStatus): number {
  return rows.filter((r) => r.status === status).length
}

export type GroupedBomsByProduct = {
  groupKey: string
  productId: string | null
  codeHint: string | null
  assembledBoms: Bom[]
  kdBoms: Bom[]
  otherBoms: Bom[]
  totalBoms: number
}

export function groupBomsByProductAndMode(rows: Bom[]): GroupedBomsByProduct[] {
  const map = new Map<string, GroupedBomsByProduct>()

  for (const r of rows) {
    const key = r.product_id || r.code_hint || 'unassigned'
    let group = map.get(key)
    if (!group) {
      group = {
        groupKey: key,
        productId: r.product_id ?? null,
        codeHint: r.code_hint ?? null,
        assembledBoms: [],
        kdBoms: [],
        otherBoms: [],
        totalBoms: 0,
      }
      map.set(key, group)
    }

    group.totalBoms += 1
    if (r.assembly_type === 'assembled') {
      group.assembledBoms.push(r)
    } else if (r.assembly_type === 'kd') {
      group.kdBoms.push(r)
    } else {
      group.otherBoms.push(r)
    }
  }

  return [...map.values()]
}
